export default "__VITE_ASSET__pV_TkPwW__"